<div class="filter-container"
     role="dialog"
     aria-modal="true"
     aria-labelledby="organisations-filter-title"
     (keydown.escape)="close()"
     (keydown.tab)="trapFocus($any($event))"
     (keydown.shift.tab)="trapFocus($any($event))">
    <div class="filter-close">
        <button type="button" class="filter-close-btn" aria-label="Close filters" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="d-flex justify-content-between align-items-center mb-3">
        <h2 id="organisations-filter-title" class="h4 mb-0 fw-bolder">Filters</h2>
    </div>

    <hr />

    <form [formGroup]="form" (submit)="applyFilter()">
        <div class="mb-3">
            <label for="organisations-filter-name" class="form-label fw-semibold">Name</label>
            <input #firstField id="organisations-filter-name" type="text" class="form-control"
                   formControlName="name" autocomplete="off" />
        </div>

        <div class="mb-3">
            <label for="organisations-filter-code" class="form-label fw-semibold">Code</label>
            <input id="organisations-filter-code" type="text" class="form-control"
                   formControlName="code" autocomplete="off" />
        </div>

        <div class="mb-3">
            <label for="organisations-filter-address" class="form-label fw-semibold">Address</label>
            <input id="organisations-filter-address" type="text" class="form-control"
                   formControlName="address" autocomplete="off" />
        </div>

        <div class="mb-3">
            <label for="organisations-filter-city" class="form-label fw-semibold">City</label>
            <input id="organisations-filter-city" type="text" class="form-control"
                   formControlName="city" autocomplete="off" />
        </div>

        <div class="mb-3">
            <label for="organisations-filter-postcode" class="form-label fw-semibold">Postcode</label>
            <input id="organisations-filter-postcode" type="text" class="form-control"
                   formControlName="postcode" autocomplete="off" />
        </div>

        @if (canSeeInactive) {
            <div class="form-check mb-3">
                <input id="organisations-filter-show-inactive" type="checkbox" class="form-check-input"
                       formControlName="showDeactivated" />
                <label for="organisations-filter-show-inactive" class="form-check-label">Show deactivated / deleted organisations</label>
            </div>
        }

        <hr />

        <div class="d-grid gap-2 mt-4">
            <button type="button" class="btn btn-gray text-dark rounded-pill fw-bold" (click)="reset()">
                Reset filters
            </button>
            <button type="submit" class="btn btn-success rounded-pill fw-bold">
                Apply filters
            </button>
        </div>
    </form>
</div>
